import {schema} from 'normalizr'

export const sponsor = new schema.Entity('sponsors')

export const roleExemption = new schema.Entity('exemptRoles')


